<template>
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21 9.16667L19.8333 8L16 11.8333L12.1667 8L11 9.16667L16 14.1667L21 9.16667ZM22.5 16.5417L20.9833 15.025L16 20.0083L11.0167 15.025L9.5 16.5417L16 23.0417L22.5 16.5417Z"
      fill="currentColor"/>
  </svg>
</template>
